exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g-page-container{min-height:calc(var(--g--dvh, 1vh) * 100 - env(safe-area-inset-bottom) - env(keyboard-inset-height, 0))}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16bd75b4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/SiteBody.vue
// module id = UK7F
// module chunks = 1